import { Col, message, Modal, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { FormikDate, FormikSubmitButton, FormikSelect } from "../FormItems";
import { Formik } from "formik";
import { Form } from "formik-antd";
import * as Yup from "yup";
import releases from "../../data/t24Releases.json";
import status from "../../data/t24Status.json";
import projectStatus from "../../data/t24ProjectStatus.json";
import * as clientReducer from "../Redux/client/reducer";
import { connect, useSelector } from "react-redux";
import moment from "moment";
import Feedback from "../Utilities/Feedback";
import { Helmet } from "react-helmet";
import { LoadingOutlined } from "@ant-design/icons";
import { StyledButton } from "../styled-components/components";
import ClientProfileCompletion from "./Profile/ClientProfileCompletion";

const initialValues = {
  t24Release: "",
  currentStatus: "",
  liveSince: "",
  projectStatus: "",
};

const validationSchema = Yup.object().shape({
  t24Release: Yup.string().required("T24 release is required"),
  currentStatus: Yup.string().required("Status of Release is required"),
  liveSince: Yup.date()
    .max(new Date(), "Live Since should be less than today")
    .typeError("Live Since is required")
    .when("currentStatus", (status, field) =>
      status === "Live" ? field.required("Live Since is required") : field
    ),
  projectStatus: Yup.string().when("currentStatus", (status, field) =>
    status !== "Live" ? field.required("Project Status is required") : field
  ),
});

const T24Profile = (props) => {
  const [openNewForm, setNewForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const { allT24Profiles } = useSelector((state) => state.clientStore);
  const { fetchProfiles, createT24Profile } = props;
  useEffect(() => {
    const fetchingAllProfiles = async () => {
      await fetchProfiles();
      setLoading(false);
    };
    fetchingAllProfiles();
  }, [fetchProfiles]);
  const newT24Profile = async (profileDetails, formActions) => {
    await createT24Profile(profileDetails);
    message.success("Profile Created", 3);
    setNewForm(false);
  };
  return (
    <Col xs={{ span: 24 }} style={{ overflowX: "hidden", marginTop: "2vh" }}>
      <Helmet title="T24 Profile | Unicon" />
      {loading ? (
        <Col>
          <Feedback title="Fetching Profiles" icon={<LoadingOutlined spin />} />
        </Col>
      ) : (
        <Col>
          <ClientProfileCompletion />
          {allT24Profiles.length === 0 ? (
            <Col>
              <Feedback
                status="404"
                title="No Profiles Found"
                subTitle={
                  <StyledButton
                    data-testid="openProfileForm"
                    onClick={() => setNewForm(true)}
                  >
                    Create Profile
                  </StyledButton>
                }
              ></Feedback>
            </Col>
          ) : (
            <Col
              style={{
                margin: "2vh",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              xl={{ span: 12 }}
            >
              <Row justify="space-between" align="middle">
                <Col>
                  <Typography.Title level={5}>All Profiles</Typography.Title>
                </Col>
                <Col>
                  <Row>
                    <StyledButton
                      data-testid="openProfileForm"
                      onClick={() => setNewForm(true)}
                    >
                      <Row align="middle">New Profile</Row>
                    </StyledButton>
                  </Row>
                </Col>
              </Row>

              {allT24Profiles.map((eachProfile) => (
                <List profile={eachProfile} key={eachProfile.id} />
              ))}
            </Col>
          )}
        </Col>
      )}
      <Modal
        visible={openNewForm}
        footer={null}
        onCancel={() => setNewForm(false)}
      >
        <NewProfile createT24Profile={newT24Profile} />
      </Modal>
    </Col>
  );
};

const List = ({ profile }) => {
  const showDate = (date) => moment(date).format("YYYY/MM/DD");
  return (
    <Col
      xl={{ span: 24 }}
      style={{
        padding: "2vh",
        background: "#ffffff",
        border: "1px solid #f4f4f4",
        margin: "2vh",
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: "2vh",
      }}
    >
      <Row>
        <Typography.Title level={5}>
          {profile.T24Release}-{profile.CurrentStatus}
        </Typography.Title>
      </Row>
      <Row>
        {profile.liveSince ? (
          <Col>
            <Typography.Text strong>Live Since: </Typography.Text>
            {profile.liveSince}
          </Col>
        ) : null}
      </Row>
      <Row>
        <Col>
          <Typography.Text strong>Created Date: </Typography.Text>
          {showDate(profile.createdDate)}
        </Col>
      </Row>
    </Col>
  );
};

const NewProfile = ({ createT24Profile }) => {
  const [showLive, setShowLive] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const getStatus = (value) => {
    if (value === "Live") {
      setShowLive(true);
      setShowStatus(false);
    } else {
      setShowLive(false);
      setShowStatus(true);
    }
  };
  const newProfile = async (profileDetails, formActions) => {
    if (profileDetails.liveSince) {
      profileDetails.liveSince = moment(profileDetails.liveSince).format(
        "YYYY-MM-DD"
      );
    }
    await createT24Profile(profileDetails);
    formActions.resetForm();
    formActions.setSubmitting(false);
  };
  return (
    <Col>
      <Row>
        <Typography.Title level={4}>Create T24 Profile</Typography.Title>
      </Row>
      <Col>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnMount
          onSubmit={newProfile}
        >
          {(formik) => {
            return (
              <Form>
                <FormikSelect
                  id="selectT24Release"
                  label="T24 Release"
                  name="t24Release"
                  options={releases}
                  callBack={false}
                  placeholder="Select Release Version"
                />
                <FormikSelect
                  id="selectCurrentStatus"
                  label="Current Status"
                  name="currentStatus"
                  options={status}
                  callBack={true}
                  getStatus={getStatus}
                  placeholder="Select Status"
                ></FormikSelect>
                {showLive ? (
                  <FormikDate id="date" name="liveSince" label="Live Since" />
                ) : null}
                {showStatus ? (
                  <FormikSelect
                    id="selectStatus"
                    label="Project Status"
                    options={projectStatus}
                    name="projectStatus"
                    callBack={false}
                    placeholder="Select Project Status"
                  ></FormikSelect>
                ) : null}
                <FormikSubmitButton
                  id="submit-createProfile"
                  disabled={!formik.isValid}
                  name="Create Profile"
                ></FormikSubmitButton>
              </Form>
            );
          }}
        </Formik>
      </Col>
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    createT24Profile: (profileDetails) =>
      dispatch(clientReducer.createT24Profile(profileDetails)),
    fetchProfiles: () => dispatch(clientReducer.getAllProfiles()),
  };
};

export default connect(null, mapDispatchToProps)(T24Profile);
